import { useNavigate } from "@entry/navigation";

import { Routes } from "@ctypes";
import { useErrorBanner } from "@hooks/application";
import { useOnboarding } from "./useOnboarding";

/**
 * Advances to the next outstanding onboarding step, or to the dashboard once none remain.
 *
 * Formerly useFutureMoneyUpgradeNavigation. It outlived the Altruist upgrade flow it was written
 * for because MaritalStatusRoute uses it too; the only upgrade-specific part was the fallback,
 * which pointed at the now-deleted upgrade success screen.
 */
export const useOnboardingNextNavigation = () => {
  const { getNextScreen } = useOnboarding();
  const { showErrorBanner } = useErrorBanner();
  const navigate = useNavigate();

  const handleNext = async () => {
    try {
      const nextScreen = await getNextScreen();

      navigate(nextScreen ?? Routes.Dashboard, { replace: true });
    } catch {
      showErrorBanner();
    }
  };

  return { handleNext };
};
